import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { GetUserActivity } from './thunks';
import { GetUserActivityReducer, ResetUserActivityStateReducer } from './reducers';

// ----------------------------------------------------------------------------

export const slice = createSlice({
  name: 'userActivity',
  initialState,
  reducers: {
    ResetUserActivityState: ResetUserActivityStateReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetUserActivity, GetUserActivityReducer);
  },
});

export default slice.reducer;
